export default "skymp5-front/bf02f8dcf9c9fe4366569342152d5ae8.png";